import { Filter } from '@cubejs-client/core';

import { TsrctNegotiationCaseStatus } from '@/generated/gql/graphql';
import { DimNegotiationCaseDimension } from '~/common/types/cubes/DimNegotiationCase';
import { FactNegotiationCaseDimension } from '~/common/types/cubes/FactNegotiationCase';
import { NegotiationStatus } from '~/common/types/NegotiationStatus';

const IGNORE_STATUS = [
  TsrctNegotiationCaseStatus.INITIALIZED,
  TsrctNegotiationCaseStatus.CANCELLED_BEFORE_INVITE_EMAIL_SENT,
];

export const statusFilterMap: { [key in NegotiationStatus]: Filter[] } = {
  [NegotiationStatus.ALL]: [
    {
      member: DimNegotiationCaseDimension.STATUS,
      operator: 'equals',
      values: Object.values(TsrctNegotiationCaseStatus).filter((p) => !IGNORE_STATUS.includes(p)),
    },
  ],
  [NegotiationStatus.FAILED]: [
    {
      member: DimNegotiationCaseDimension.STATUS,
      operator: 'equals',
      values: [TsrctNegotiationCaseStatus.NO_AGREEMENT_REACHED],
    },
  ],
  [NegotiationStatus.RUNNING]: [
    {
      member: DimNegotiationCaseDimension.STATUS,
      operator: 'equals',
      values: [
        TsrctNegotiationCaseStatus.CONTACT_DETAILS_CONFIRMED,
        TsrctNegotiationCaseStatus.INVITE_EMAIL_OPENED,
        TsrctNegotiationCaseStatus.INVITE_EMAIL_SENT,
        TsrctNegotiationCaseStatus.LINK_OPENED,
        TsrctNegotiationCaseStatus.MANUAL_NEGOTIATION,
        TsrctNegotiationCaseStatus.NEGOTIATION_DETAILS_CONFIRMED,
        TsrctNegotiationCaseStatus.NEGOTIATION_OPENED,
        TsrctNegotiationCaseStatus.AGREEMENT_REACHED,
      ],
    },
  ],
  [NegotiationStatus.SUCCESSFUL]: [
    {
      member: DimNegotiationCaseDimension.STATUS,
      operator: 'equals',
      values: [
        TsrctNegotiationCaseStatus.AGREEMENT_CONFIRMED,
        TsrctNegotiationCaseStatus.AWARDED,
        TsrctNegotiationCaseStatus.OFFER_DISMISSED, // This can be discussed...
      ],
    },
  ],
  [NegotiationStatus.CANCELLED]: [
    {
      member: DimNegotiationCaseDimension.STATUS,
      operator: 'equals',
      values: [TsrctNegotiationCaseStatus.CANCELLED_AFTER_INVITE_EMAIL_SENT],
    },
  ],
  [NegotiationStatus.CANCELLED_BY_SYSTEM]: [
    {
      member: DimNegotiationCaseDimension.STATUS,
      operator: 'equals',
      values: [TsrctNegotiationCaseStatus.CANCELLED_AFTER_INVITE_EMAIL_SENT],
    },
    {
      member: FactNegotiationCaseDimension.TIME_TO_CANCELLED_BY_SYSTEM,
      operator: 'set',
    },
  ],
  [NegotiationStatus.CANCELLED_BY_USER]: [
    {
      member: DimNegotiationCaseDimension.STATUS,
      operator: 'equals',
      values: [TsrctNegotiationCaseStatus.CANCELLED_AFTER_INVITE_EMAIL_SENT],
    },
    {
      member: FactNegotiationCaseDimension.TIME_TO_CANCELLED_BY_USER,
      operator: 'set',
    },
  ],
};
